<template>
    <div class="cloudWrap">
		<vue-seamless-scroll :data="newsList" :class-option="optionLeft" class="seamless-warp2">
			<ul class="item" :style="{'width':`${windowWidth*2}px`}">
				<li v-for="(item,index) in newsList" :style="{'width':`${windowWidth}px`}" :key="index">
					<img class="cloud_01" :src="`${imgPath}/static/assets/img/cloud/cloud_01.png`" width="100%" />
					<img class="cloud_02" :src="`${imgPath}/static/assets/img/cloud/cloud_02.png`" width="100%" />
					<img class="cloud_03" :src="`${imgPath}/static/assets/img/cloud/cloud_03.png`" width="100%" />
				</li>
			</ul>
		</vue-seamless-scroll>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
		name:'cloud',
		data () {
            return {
				newsList: 
					[1,2],
					windowWidth: document.documentElement.clientWidth,
                }
			},
			components: {
				vueSeamlessScroll
			},
            computed: {    
                optionLeft () {
                    return {
						direction: 2,
						limitMoveNum: 1,
						hoverStop: false,
						step: 0.2
					}
                },
            }
	}
</script>
<style>
.seamless-warp2>div>div{
	margin-left: -5%;
}
</style>
<style lang="scss" scope>
	@import "../assets/css/cloud.scss";
</style>


// WEBPACK FOOTER //
// src/components/cloud.vue